import { Injectable } from '@angular/core';
import { SyskaServicePkg } from './syskaPkg.service';

@Injectable({
  providedIn: 'root',
})
export class SyskaService extends SyskaServicePkg {
  constructor() {
    super();
  }
}
